module.exports = __webpack_public_path__ + "ollie-0eeafaa4.png";